import { Route, Redirect } from "react-router-dom";
import auth from "../../services/authService";

// adminRedirect makes the route admin-only: given the route's params, it says where anyone else is sent
const ProtectedRoute = ({ path, component: Component, render, adminRedirect, ...rest }) => {
  return (
    <Route
      // path={path}
      {...rest}
      render={(props) => {
        const user = auth.getCurrentUser();

        if (!user)
          return (
            <Redirect
              to={{
                pathname: "/signin",
                state: { from: props.location },
              }}
            />
          );
        if (adminRedirect && !user.isAdmin) return <Redirect to={adminRedirect(props.match.params)} />;
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;
